import type { DeleteImpactRatingsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  DeleteImpactRatingsDocument,
  namedOperations,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteImpactRatings = createMutationHook({
  name: 'deleteImpactRatings',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.impactRating.deleteBatch.mutationOptions({ onSuccess }),
  mapInput: (variables: { Ids: string[] }) => ({ Ids: variables.Ids }),
  invalidate: (trpc) => [
    trpc.frontend.impactRating.impactRatings.queryKey(),
    trpc.frontend.impactRating.impactRatingById.queryKey(),
    trpc.frontend.impactRating.impactRatingsByImpactId.queryKey(),
    trpc.frontend.impactRating.impactRatingsByRatedItemId.queryKey(),
    trpc.frontend.impactRating.impactRatingsWithAppetites.queryKey(),
    trpc.frontend.impactRating.impactRatingCount.queryKey(),
    // Assessment views may show rating data
    trpc.frontend.assessment.register.queryKey(),
    trpc.frontend.assessment.resultsRegister.queryKey(),
    // COI-889: the risk register's impact-performance badge and rating-trend
    // arrow are derived from these ratings.
    trpc.frontend.risk.register.queryKey(),
  ],
  mapResponse: (
    _result,
    variables: { Ids: string[] }
  ): DeleteImpactRatingsMutation => ({
    delete_impact_rating: {
      __typename: 'impact_rating_mutation_response',
      affected_rows: variables.Ids.length,
    },
  }),
  graphqlDocument: DeleteImpactRatingsDocument,
  graphqlVariables: (variables: { Ids: string[] }) => ({ Ids: variables.Ids }),
  evictFields: ['impact_rating'],
  // The impactRating nav badge count query uses fetchPolicy: 'no-cache',
  // so evicting cache fields does not refresh it — refetch it explicitly.
  refetchQueries: [namedOperations.Query.getImpactRatingCount],
});
